import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/offices', request)
}

async function post(request) {
    return await postMethod('/api/offices', request)
}

async function put(request) {
    return await putMethod('/api/offices', request)
}

async function patch(request) {
    return await patchMethod('/api/offices', request)
}

export {get, post, put, patch}
